export default __webpack_public_path__ + "static/german-2-b09ace65a6a7e5b51bc3e625aacaaafe.png";